// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResult__result___dYz5a {
    margin: 5px 5px;
}

.SearchResult__favoriteResult___AEAco {
    position: relative;
    margin: 5px 0;
    padding-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    opacity: 0.8;
    transition:
        opacity 140ms ease,
        text-shadow 140ms ease;
}

.SearchResult__favoriteResult___AEAco::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 4px;
    width: 3px;
    height: 3px;
    background: rgba(200, 159, 88, 0.58);
    border-radius: 50%;
    transform: translateY(-50%);
    transition:
        background-color 140ms ease,
        box-shadow 140ms ease;
}

.SearchResult__favoriteResult___AEAco:hover,
.SearchResult__favoriteResult___AEAco:focus-within {
    opacity: 1;
    text-shadow: 0 0 5px rgba(222, 177, 93, 0.62);
}

.SearchResult__favoriteResult___AEAco:hover::before,
.SearchResult__favoriteResult___AEAco:focus-within::before {
    background: rgba(238, 197, 113, 0.92);
    box-shadow: 0 0 6px rgba(222, 168, 74, 0.42);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"result": `SearchResult__result___dYz5a`,
	"favoriteResult": `SearchResult__favoriteResult___AEAco`
};
module.exports = ___CSS_LOADER_EXPORT___;
